import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Styled from 'app/components/Checkbox/Checkbox.styled';
import KEY_CODES from 'app/constants/keyCodes';
import noop from 'app/libs/noop';

const Checkbox = ({ children, isChecked, onChange, testId }) => {
  const handleKeyDown = useCallback(({ keyCode, target }) => {
    if ([KEY_CODES.SPACE, KEY_CODES.ENTER].includes(keyCode)) {
      target.click();
    }
  }, []);

  return (
    <Styled.Checkbox>
      <Styled.Label
        isChecked={isChecked}
        tabIndex="0"
        onKeyDown={handleKeyDown}
        data-t={testId}
      >
        <Styled.Input type="checkbox" value={isChecked} onChange={onChange} />
        <Styled.Checkmark>
          <Styled.Svg viewBox="2 2 16 16">
            <Styled.Path
              d="M6,10 C7.93333333,12 8.93333333,13 9,13 C9.06666667,13 10.7333333,11 14,7"
              strokeWidth="2"
            />
          </Styled.Svg>
        </Styled.Checkmark>
        {children}
      </Styled.Label>
    </Styled.Checkbox>
  );
};

Checkbox.propTypes = {
  isChecked: PropTypes.bool,
  children: PropTypes.node,
  onChange: PropTypes.func,
  testId: PropTypes.string,
};

Checkbox.defaultProps = {
  isChecked: false,
  children: '',
  onChange: noop(),
  testId: 'checkbox',
};

export default Checkbox;
